import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Leaderboard.css";

const Leaderboard = () => {

  const [players, setPlayers] = useState([]);
  const [metric, setMetric] = useState("reaction");

  useEffect(() => {
    fetchLeaderboard();
  }, [metric]);

  const fetchLeaderboard = async () => {

    try {

      const email = localStorage.getItem("rg_email");

      const url =
        metric === "visual"
          ? `/api/leaderboard-visual-acuity?email=${email}`
            : metric === "colorVision"   // ✅ ADD THIS
          ? `/colorvision-leaderboard?email=${email}`
          : metric === "reaction"
          ? `/api/reaction-leaderboard?email=${email}`
          : metric === "complex"
          ? `/complexleaderboard?email=${email}`
          : metric === "shortTerm"   // 🔥 ADD THIS
          ? `/shorttermleaderboard?email=${email}`
          : metric === "memory"
          ? `/workingmemoryleaderboard?email=${email}`
          : metric === "search"
          ? `/searchspanleaderboard?email=${email}`
          : `/anticipationleaderboard?email=${email}`;

      const res = await axios.get(url);

      const data = res.data?.leaderboard || [];

      // 🔥 TOP 3 ONLY
      setPlayers(data.slice(0, 3));

    } catch (err) {
      console.error("Leaderboard error:", err);
    }

  };

  return (

    <div className="leaderboard-layout">

      <div className="leaderboard-container">

        <div className="leaderboard-card">

          <h1 className="title">ForgeYourPeak Leaderboard</h1>

          <p className="subtitle">
            Compare performance across athletes using ForgeYourPeak metrics.
            This view shows <b>Top 3</b> plus your current rank.
          </p>

          <div className="leaderboard-meta">
            <span className="meta-badge">Live Rankings</span>

            <span className="meta-badge">
              Updated: {new Date().toLocaleDateString("en-US", {
                month: "short",
                day: "2-digit",
                year: "numeric"
              })}
            </span>
          </div>

          <hr className="divider" />

          {/* ================= TABS ================= */}

          <div className="tabs">

            <button className={metric === "visual" ? "active" : ""} onClick={() => setMetric("visual")}>Visual Acuity</button>
            <button className={metric === "colorVision" ? "active" : ""} onClick={() => setMetric("colorVision")}>Color Vision</button>

            <button className={metric === "reaction" ? "active" : ""} onClick={() => setMetric("reaction")}>Reaction Speed</button>

            <button className={metric === "complex" ? "active" : ""} onClick={() => setMetric("complex")}>Complex Reaction</button>

            <button className={metric === "memory" ? "active" : ""} onClick={() => setMetric("memory")}>Working Memory</button>

            <button className={metric === "search" ? "active" : ""} onClick={() => setMetric("search")}>Search Span</button>

            <button className={metric === "anticipation" ? "active" : ""} onClick={() => setMetric("anticipation")}>Anticipation</button>
            <button className={metric === "shortTerm" ? "active" : ""} onClick={() => setMetric("shortTerm")}> Short-Term Visual Memory</button>

          </div>

          {/* ================= TABLE ================= */}

          <table className="leaderboard-table">

            <thead>

              {metric === "visual" && (
                <tr><th>Rank</th><th>Name</th><th>Acuity</th><th>Percentile</th></tr>
              )}
              {metric === "colorVision" && (<tr> <th>Rank</th><th>Name</th><th>Score</th><th>Percentile</th></tr>
   )}

              {(metric === "reaction" || metric === "complex") && (
                <tr><th>Rank</th><th>Name</th><th>Best Reaction</th><th>Percentile</th></tr>
              )}
              {metric === "shortTerm" && (
                <tr> <th>Rank</th><th>Name</th><th>Level</th><th>Percentile</th></tr>
              )}

              {metric === "memory" && (
                <tr><th>Rank</th><th>Name</th><th>Level</th><th>Percentile</th></tr>
              )}

              {(metric === "search" || metric === "anticipation") && (
                <tr><th>Rank</th><th>Name</th><th>Score</th><th>Percentile</th></tr>
              )}

            </thead>

            <tbody>

              {players.map((player, index) => {

                const medal =
                  index === 0 ? "🥇" :
                  index === 1 ? "🥈" :
                  index === 2 ? "🥉" : "";

                const rank = player.rank || index + 1;

                return (

                  <tr key={index}>

                    <td>{rank} {medal}</td>
                    <td>{player.name}</td>

                    {metric === "visual" && (
                      <>
                      <td>{player.acuity || "-"}</td>
                      <td>{player.percentile ? player.percentile + "%" : "-"}</td>
                    </>
                  )}
                    {metric === "colorVision" && (
                      <>
                      <td>{player.score || "-"}</td>
                      <td>{player.percentile ? player.percentile + "%" : "-"}</td>
                      </>
    )}

                  {/* REACTION + COMPLEX */}
                  {(metric === "reaction" || metric === "complex") && (
                    <>
                      <td>
                        {(player.bestPoints || player.bestReaction)
                          ? ((player.bestPoints || player.bestReaction) * 1000).toFixed(0) + " ms"
                          : "-"}
                      </td>
                      <td>{player.percentile ? player.percentile + "%" : "-"}</td>
                    </>
                  )}
                  {metric === "shortTerm" && (
                    <>
                      <td>{player.level || "-"}</td>
                      <td>{player.percentile ? player.percentile + "%" : "-"}</td>
                    </>
                  )}

                  {/* WORKING MEMORY */}
                  {metric === "memory" && (
                    <>
                      <td>{player.level || player.bestLevel || "-"}</td>
                      <td>{player.percentile ? player.percentile + "%" : "-"}</td>
                    </>
                  )}

                  {/* SEARCH + ANTICIPATION */}
                  {(metric === "search" || metric === "anticipation") && (
                    <>
                      <td>{player.score || player.score || "-"}</td>
                      <td>{player.percentile ? player.percentile + "%" : "-"}</td>
                    </>
                  )}

                  </tr>

                );

              })}

            </tbody>

          </table>

        </div>

      </div>

      {/* ================= RIGHT PANEL ================= */}

      <div className="lecture-container">

      <div className="lecture-card">

        <div className="lecture-badge">
          🎧 Metric Lecture
        </div>

        {/* ================= VISUAL ACUITY ================= */}
        {metric === "visual" && (
          <>
            <h3>Why Visual Acuity matters</h3>

            <p className="lecture-text">
              In sport, your eyes are the entry point for timing.
              Better acuity helps you pick up fine details earlier —
              seam/spin, body cues, and ball release — so your brain
              gets extra milliseconds to decide and move.
            </p>

            <audio controls className="audio-player">
              <source src="/audio/Visual_Acuity.mp3" type="audio/mpeg" />
            </audio>

            <div className="visual-card">

              <h4>
                Visual Acuity → Earlier Pickup → Better Timing
              </h4>

              <p className="visual-sub">
                Sharper resolution buys you decision time in fast sports.
              </p>

              <div className="flow">

                <div className="flow-box blue">
                  Sharper Detail
                  <span>Seam • Spin • Release</span>
                </div>

                <div className="flow-box gray">
                  Earlier Processing
                  <span>More time to decide</span>
                </div>

                <div className="flow-box red">
                  Cleaner Action
                  <span>Better timing & control</span>
                </div>

              </div>

            </div>
          </>
        )}
        {metric === "colorVision" && (
          <>
            <h3>Why Color Vision matters</h3>

            <p className="lecture-text">
              Color vision helps athletes quickly distinguish objects,
              signals, and patterns. It improves tracking accuracy,
              decision-making, and performance under dynamic conditions.
            </p>

            <audio controls className="audio-player">
              <source src="/audio/ColorVision.mp3" type="audio/mpeg" />
            </audio>

            <div className="visual-card">

              <h4>
                Color Vision → Recognition → Faster Decisions
              </h4>

              <p className="visual-sub">
                Better color perception improves clarity and reaction.
              </p>

              <div className="flow">

                <div className="flow-box blue">
                  Detect Colors
                  <span>Objects / signals</span>
                </div>

                <div className="flow-box gray">
                  Differentiate
                  <span>Quick identification</span>
                </div>

                <div className="flow-box red">
                  React Faster
                  <span>Better performance</span>
                </div>

              </div>

            </div>
          </>
        )}

        {/* ================= REACTION SPEED ================= */}
        {metric === "reaction" && (
          <>
            <h3>Why Reaction Speed matters</h3>

            <p className="lecture-text">
              Reaction speed determines how fast your brain processes
              visual signals and converts them into action.
              Faster reactions help athletes respond instantly
              to unpredictable situations in sport.
            </p>

            <audio controls className="audio-player">
              <source src="/audio/Reaction_Speed.mp3" type="audio/mpeg" />
            </audio>

            <div className="visual-card">

              <h4>
                Reaction Speed → Faster Decision → Faster Movement
              </h4>

              <p className="visual-sub">
                Quick brain processing improves response time.
              </p>

              <div className="flow">

                <div className="flow-box blue">
                  Visual Signal
                  <span>Ball / stimulus appears</span>
                </div>

                <div className="flow-box gray">
                  Brain Processing
                  <span>Recognize & decide</span>
                </div>

                <div className="flow-box red">
                  Physical Response
                  <span>Move / react instantly</span>
                </div>

              </div>

            </div>
          </>
        )}

        {/* ================= COMPLEX REACTION ================= */}
        {metric === "complex" && (
          <>
            <h3>Why Complex Reaction matters</h3>

            <p className="lecture-text">
              Complex reaction tests your ability to choose the correct response
              among multiple options. It improves decision-making speed
              under pressure — critical in real game situations.
            </p>
            <audio controls className="audio-player">
              <source src="/audio/ComplexReaction.mp3" type="audio/mpeg" />
            </audio>

            <div className="visual-card">

              <h4>
                Complex Reaction → Decision Accuracy → Game Intelligence
              </h4>

              <p className="visual-sub">
                Faster decisions with multiple choices.
              </p>

              <div className="flow">

                <div className="flow-box blue">
                  Multiple Stimuli
                  <span>Different signals appear</span>
                </div>

                <div className="flow-box gray">
                  Decision Selection
                  <span>Choose correct response</span>
                </div>

                <div className="flow-box red">
                  Correct Action
                  <span>Execute instantly</span>
                </div>

              </div>

            </div>
          </>
        )}
        {/* ================= SHORT TERM MEMORY ================= */}
        {metric === "shortTerm" && (
          <>
            <h3>Why Short-Term Visual Memory matters</h3>

            <p className="lecture-text">
              Short-term memory helps you retain visual information briefly
              and reproduce it accurately. It is crucial for recalling recent
              movements, sequences, and patterns in fast-paced sports.
            </p>

            <audio controls className="audio-player">
              <source src="/audio/VisualMemory.mp3" type="audio/mpeg" />
            </audio>

            <div className="visual-card">

              <h4>
                Short-Term Memory → Recall → Execution
              </h4>

              <p className="visual-sub">
                Remember fast. Act faster.
              </p>

              <div className="flow">

                <div className="flow-box blue">
                  See Pattern
                  <span>Cards / sequence</span>
                </div>

                <div className="flow-box gray">
                  Store Briefly
                  <span>Short-term retention</span>
                </div>

                <div className="flow-box red">
                  Recall & Execute
                  <span>Correct sequence</span>
                </div>

              </div>

            </div>
          </>
        )}

        {/* ================= WORKING MEMORY ================= */}
        {metric === "memory" && (
          <>
            <h3>Why Working Memory matters</h3>

            <p className="lecture-text">
              Working memory allows you to hold and process information
              in real time. Athletes use it to track patterns, positions,
              and sequences during play.
            </p>
            <audio controls className="audio-player">
              <source src="/audio/WorkingMemory.mp3" type="audio/mpeg" />
            </audio>

            <div className="visual-card">

              <h4>
                Memory → Pattern Tracking → Smart Decisions
              </h4>

              <p className="visual-sub">
                Hold more information under pressure.
              </p>

              <div className="flow">

                <div className="flow-box blue">
                  Store Info
                  <span>Positions & patterns</span>
                </div>

                <div className="flow-box gray">
                  Process
                  <span>Analyze quickly</span>
                </div>

                <div className="flow-box red">
                  Execute
                  <span>Better decisions</span>
                </div>

              </div>

            </div>
          </>
        )}

        {/* ================= SEARCH SPAN ================= */}
        {metric === "search" && (
          <>
            <h3>Why Search Span matters</h3>

            <p className="lecture-text">
              Search span measures how efficiently you scan visual fields.
              It improves awareness, attention, and the ability to locate
              key targets quickly.
            </p>
            <audio controls className="audio-player">
                <source src="/audio/SearchSpan.mp3" type="audio/mpeg" />
              </audio>

            <div className="visual-card">

              <h4>
                Search → Scan → Find Faster
              </h4>

              <p className="visual-sub">
                Faster scanning = better awareness.
              </p>

              <div className="flow">

                <div className="flow-box blue">
                  Visual Scan
                  <span>Scan environment</span>
                </div>

                <div className="flow-box gray">
                  Target Detection
                  <span>Find key objects</span>
                </div>

                <div className="flow-box red">
                  Quick Action
                  <span>React faster</span>
                </div>

              </div>

            </div>
          </>
        )}

        {/* ================= ANTICIPATION ================= */}
        {metric === "anticipation" && (
          <>
            <h3>Why Anticipation matters</h3>

            <p className="lecture-text">
              Anticipation helps you predict what will happen next.
              Elite athletes don’t react — they anticipate before events occur.
            </p>
            <audio controls className="audio-player">
              <source src="/audio/Anticipation.mp3" type="audio/mpeg" />
            </audio>

            <div className="visual-card">

              <h4>
                Anticipation → Prediction → Early Movement
              </h4>

              <p className="visual-sub">
                Predict before it happens.
              </p>

              <div className="flow">

                <div className="flow-box blue">
                  Read Cues
                  <span>Body / motion hints</span>
                </div>

                <div className="flow-box gray">
                  Predict
                  <span>Future movement</span>
                </div>

                <div className="flow-box red">
                  Pre-React
                  <span>Move earlier</span>
                </div>

              </div>

            </div>
          </>
        )}

      </div>

    </div>

      

    </div>
  );

};

export default Leaderboard;